import { useQuery } from '@apollo/client';

import { MatchingTier } from '../types';
import { MATCHING_SELECTION_LIST } from '../gql';

export interface MatchingPoolItem {
  readonly questionnaireId: number;
  readonly displayName: string;
  readonly tier: MatchingTier;
  readonly startSurroSearch: string | null;
  readonly state: string | null;
  readonly country: string | null;
}

interface MatchingSelectionListData {
  matchingSelectionList: MatchingPoolItem[];
}

// Stable identity — a fresh `[]` per render would re-fire every effect depending on `pool`.
const EMPTY_POOL: MatchingPoolItem[] = [];

export const useMatchingPool = () => {
  const { data, loading, error, refetch } = useQuery<MatchingSelectionListData>(MATCHING_SELECTION_LIST, {
    // Every page entry re-fetches — B2's freshness requirement (re-entry reconciliation needs the
    // current pool, not a cached one).
    fetchPolicy: 'network-only',
  });

  return { pool: data?.matchingSelectionList ?? EMPTY_POOL, loading, error, refetch };
};
